import { render, staticRenderFns } from "./RunRating.vue?vue&type=template&id=d0c98d30"
import script from "./RunRating.vue?vue&type=script&lang=js"
export * from "./RunRating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports